/**
 * @description logo信息
 */
import React, { FC } from 'react';
import { getSite } from '@/common/constants/platform-constants';
import cn from 'classnames';
import s from './index.module.less';
import { SiteLogo } from './methods';

interface ILogos {
  className?: string
}

const Logos: FC<ILogos> = ({ className }) => (
  <div className={cn(s.logos, className)}>
    {
      SiteLogo[getSite()].map(item => (
        <div className={s.logo} key={item.key}>
          <a href={item.href}>
            <img src={item.img} alt="logo" style={{ height: '20px' }} />
          </a>
        </div>
      ))
    }
  </div>

);

export default Logos;
